import { render, staticRenderFns } from "./GoodsInDatatable.vue?vue&type=template&id=8d0c0574&scoped=true"
import script from "./GoodsInDatatable.ts?vue&type=script&lang=ts&external"
export * from "./GoodsInDatatable.ts?vue&type=script&lang=ts&external"
import style0 from "./GoodsInDatatable.scss?vue&type=style&index=0&id=8d0c0574&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0c0574",
  null
  
)

export default component.exports